/* unplugin-vue-components disabled */import { render } from "./emj.vue?vue&type=template&id=63c1ea8a&scoped=true&ts=true"
import script from "./emj.vue?vue&type=script&lang=ts"
export * from "./emj.vue?vue&type=script&lang=ts"

import "./emj.vue?vue&type=style&index=0&id=63c1ea8a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63c1ea8a"]])

export default __exports__